import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { NgxPermissionsService } from 'ngx-permissions';

import { environment } from '@env';

@Injectable({
    providedIn: 'root'
})
export class DocumentService {
    constructor(
        private router: Router,
        private http: HttpClient,
        private ngxPermissionsService: NgxPermissionsService
    ) { }

    /**
     * Get member data
     */
    get(memberId: number): Observable<documentGetResponse> {
        return this.http.get<documentGetResponse>(`${environment.apiUrl}documents/${memberId}`);
    }
    
    updateOption(memberId: number, key: string, value: boolean): Observable<null> {
        return this.http.put<null>(`${environment.apiUrl}documents/${memberId}/option`, {
            key: key,
            value: value,
        });
    }

    uploadDocument(memberId: number, key: string, file: File): Observable<null> {
        let formData: FormData = new FormData();
        formData.append('key', key);
        formData.append('uploadFile', file, file.name);

        let headers: HttpHeaders = new HttpHeaders();
        // headers.append('Content-Type', 'multipart/form-data');
        headers.append('Accept', 'application/json');

        return this.http.post<null>(`${environment.apiUrl}documents/${memberId}/upload`, formData, {
            headers: headers,
        });
    }
}

export interface documentGetResponse {
    documents: documentGetDocumentItem[];
    options: documentGetOptionItem[];
}

export interface documentGetDocumentItem {
    key: string;
    name: string;
    files: {
        id: number;
        type: string;
        category: string;
        name: string;
        public_url: string;
    }[]; // Document
}

export interface documentGetOptionItem {
    key: string;
    name: string;
    value: boolean;
}

